<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-card
	class="config-card"
	appearance="outlined"
>
	<mat-card-header class="config-header">
		<mat-card-title>
			{{ layerConfigurationInput.name }}
		</mat-card-title>

		<div class="region-info">
			<div>
				Region: <span class="config-value"> {{ layerConfigurationInput.region }}</span>
			</div>

			@if (layerConfigurationInput.cloudProvider) {
				<div>
					Cloud provider:
					<span class="config-value">{{ layerConfigurationInput.cloudProvider }}</span>
				</div>
			} @else {
				<div>
					PUE:
					<span class="config-value">
						{{ getRoundedValueConfigInputPue() | maxDecimals: 2 }}
					</span>
				</div>
			}
		</div>
	</mat-card-header>

	<mat-card-content>
		<div class="data-grid">
			<div class="load-title">CPU load</div>

			<table class="table">
				<thead>
					<tr>
						@for (time of timeRanges; track $index) {
							<td class="time">{{ time }}</td>
						}
					</tr>
				</thead>

				<tbody>
					<td>
						{{ layerConfigurationInput.cpuLoad.night | maxDecimals: 2 }}
					</td>

					<td>
						{{ layerConfigurationInput.cpuLoad.morning | maxDecimals: 2 }}
					</td>

					<td>
						{{ layerConfigurationInput.cpuLoad.afternoon | maxDecimals: 2 }}
					</td>

					<td>
						{{ layerConfigurationInput.cpuLoad.evening | maxDecimals: 2 }}
					</td>
				</tbody>
			</table>
		</div>

		<div class="data-grid">
			<div class="load-title">GPU load</div>

			<table class="table">
				<thead>
					<tr>
						@for (time of timeRanges; track $index) {
							<td class="time">{{ time }}</td>
						}
					</tr>
				</thead>

				<tbody>
					<td>
						{{ layerConfigurationInput.gpuLoad.night | maxDecimals: 2 }}
					</td>

					<td>
						{{ layerConfigurationInput.gpuLoad.morning | maxDecimals: 2 }}
					</td>

					<td>
						{{ layerConfigurationInput.gpuLoad.afternoon | maxDecimals: 2 }}
					</td>

					<td>
						{{ layerConfigurationInput.gpuLoad.evening | maxDecimals: 2 }}
					</td>
				</tbody>
			</table>
		</div>

		<div class="config-actions">
			@if (isEditable) {
				<globalictcc-button
					label="Edit configuration"
					[textOnly]="true"
					iconName="edit"
					(handleClick)="handleEditLayer.emit(layerConfigurationInput)"
				/>
			}
		</div>
	</mat-card-content>
</mat-card>
